import { ModelBase } from '../../core/model/model-base';
import { Money } from '../../core/model/money';

export class KeyTypeCoding extends ModelBase {
  accountPlanId: string;
  incomeAccountId: string;
  accountPlanName: string;
}

export class TypeOfKey extends ModelBase {
  constructor(context?: any) {
    super();
    if (context) {
      this.name = context.name;
      this.keyPrice = context.keyPrice;
      this.vatPercentage = context.vatPercentage;
      this.currencyCode = context.currencyCode;
      this.codings = Array.isArray(context.codings) ? context.codings : [];
    }
  }

  name: string;
  keyPrice: Money;
  codings: KeyTypeCoding[] = [];
  vatPercentage = 0;
  currencyCode: string;

  toString() {
    return `${this.name}`;
  }
}
